// src/components/ArrowNav.js
import { useEffect, useState } from "react";

export default function ArrowNav({
    onPrev,
    onNext,
    autoHideMs = 1800,
    className = "",
    showLeft = true,
    showRight = true,
}) {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        if (!visible) return;
        const t = setTimeout(() => setVisible(false), autoHideMs);
        return () => clearTimeout(t);
    }, [visible, autoHideMs]);

    // Pfeile beim Interagieren wieder einblenden
    useEffect(() => {
        const show = () => setVisible(true);
        window.addEventListener("touchstart", show, { passive: true });
        window.addEventListener("scroll", show, { passive: true });
        return () => {
            window.removeEventListener("touchstart", show);
            window.removeEventListener("scroll", show);
        };
    }, []);

    return (
        <div
            className={`arrow-nav ${visible ? "is-visible" : ""} ${className}`}
            aria-hidden={!visible}
        >
            <button
                type="button"
                className="arrow-btn left"
                aria-label="Nach links"
                onClick={onPrev}
                hidden={!showLeft} 
            >
                <svg viewBox="0 0 24 24" width="45" height="45" aria-hidden="true">
                    <path d="M15 6 L9 12 L15 18" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
            <button
                type="button"
                className="arrow-btn right"
                aria-label="Nach rechts"
                onClick={onNext}
                hidden={!showRight}  
            >
                <svg viewBox="0 0 24 24" width="45" height="45" aria-hidden="true">
                    <path d="M9 6 L15 12 L9 18" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
        </div>
    );
}
